export function buildFormData<T = unknown>(data: T): FormData {
  const formData = new FormData();

  function buildFormDataRecursive(prefix: string, value: unknown) {
    if (value === undefined || value === null) return;

    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        const arrayKey = `${prefix}[${index}]`;
        if (
          typeof item === 'object' &&
          item !== null &&
          !(item instanceof Blob) &&
          !(item instanceof Date)
        ) {
          // Se for objeto, processar suas propriedades
          Object.entries(item as Record<string, unknown>).forEach(([propKey, propValue]) => {
            buildFormDataRecursive(`${arrayKey}.${propKey}`, propValue);
          });
        } else {
          // Se for primitivo, Blob ou Date
          buildFormDataRecursive(arrayKey, item);
        }
      });
    } else if (
      typeof value === 'object' &&
      value !== null &&
      !(value instanceof Blob) &&
      !(value instanceof Date)
    ) {
      Object.entries(value as Record<string, unknown>).forEach(([objKey, objValue]) => {
        const newKey = prefix ? `${prefix}.${objKey}` : objKey;
        buildFormDataRecursive(newKey, objValue);
      });
    } else {
      // Primitivos, Blob, Date
      if (value instanceof Blob) {
        formData.append(prefix, value);
      } else if (value instanceof Date) {
        formData.append(prefix, value.toISOString());
      } else if (
        typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean'
      ) {
        formData.append(prefix, String(value));
      }
    }
  }

  if (data) {
    buildFormDataRecursive('', data);
  }

  return formData;
}
